export default __webpack_public_path__ + "static/media/7SG12.7fb4461a.jpg";